export interface DownloadObjFile {
  name: string
  type: string
  blobId?: string | null
}

/**
 * attachment/inline 이미지 다운로드 결과 홀더.
 * blob URL(path, downloadPath)의 수명은 이 객체가 관리하지 않고
 * jmapDownloadCache의 beforeRemoveSaveData 훅이 단일 책임으로 담당한다.
 */
export class DownloadObj {
  file: DownloadObjFile | null = null
  blob: Blob | null = null
  path: string | null = null
  downloadPath: string | null = null
  text?: string
  newFileName?: string
  saveFile?: () => void
}
